import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { FloatingActions } from './components/FloatingActions';
import { Home } from './pages/Home';
import { Commodities } from './pages/Commodities';
import { LiveOrders } from './pages/LiveOrders';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0
    });
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="31ctetq51dy84">
      <ScrollToTop data-id="element-1" data-mp="2wk06yte9u9rt" />
      <div className="flex min-h-screen w-full flex-col bg-ink" data-id="element-2" data-mp="2wjqhr811w6n6">
        <Header data-id="element-3" data-mp="2wi5qbra193tj" />
        <main className="flex-1" data-id="element-4" data-mp="28u5z6q8t7bef">
          <Routes data-id="element-5" data-mp="28t4lsf4bmctj">
            <Route path="/" element={<Home data-id="element-7" data-mp="28s31dk1f0dz5" />} data-id="element-6" data-mp="28sl4n0mhvsgk" />
            <Route path="/commodities" element={<Commodities data-id="element-9" data-mp="23utcc5hxu4bu" />} data-id="element-8" data-mp="23vupqgmff2wq" />
            <Route path="/live-orders" element={<LiveOrders data-id="element-11" data-mp="3ikh5c1uvgeva" />} data-id="element-10" data-mp="23ti864kkyuk7" />
            <Route path="/about" element={<About data-id="element-13" data-mp="3ihuyy5jpw5en" />} data-id="element-12" data-mp="3ij61k21ff746" />
            <Route path="/contact" element={<Contact data-id="element-15" data-mp="3mkhnnxl3da7m" />} data-id="element-14" data-mp="3mlayb9n68jv1" />
          </Routes>
        </main>
        <Footer data-id="element-16" data-mp="3rc9co3oln7vn" />
        <FloatingActions data-id="element-17" data-mp="3rbrbqtqzs5he" />
      </div>
    </BrowserRouter>;
}